/**
 * @group Components
 * @summary MailIcon icon component.
 * @example
 * ```tsx
 * <MailIcon />
 * ```
 */
export const MailIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'currentcolor' }}
   >
      <path
        d="M3 5.75C3 5.33579 3.33579 5 3.75 5H20.25C20.6642 5 21 5.33579 21 5.75V18.25C21 18.6642 20.6642 19 20.25 19H3.75C3.33579 19 3 18.6642 3 18.25V5.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M4 6L12 12L20 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};


